import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Typography from "@mui/material/Typography"
import { Button } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"

const ModalCloseCertZeroConfirm = ({
  open,
  onClose,
  onAccept,
  partidaCount,
  totalPartidasCount,
}) => {
  const total = Math.max(totalPartidasCount, partidaCount)
  const bodyText =
    partidaCount === 1
      ? total === 1
        ? i18n.t("modalCloseCertZeroConfirm.bodyOneOfOne")
        : i18n.t("modalCloseCertZeroConfirm.bodyOneOfMany", { total })
      : i18n.t("modalCloseCertZeroConfirm.bodyMany", {
          count: partidaCount,
          total,
        })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {i18n.t("modalCloseCertZeroConfirm.title")}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">{bodyText}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} color="secondary" variant="text">
          {i18n.t("buttons.cancel")}
        </Button>
        <Button
          onClick={onAccept}
          color="branded"
          variant="contained"
          sx={{ width: 175, height: 36 }}
        >
          {i18n.t("buttons.accept")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ModalCloseCertZeroConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  partidaCount: PropTypes.number.isRequired,
  totalPartidasCount: PropTypes.number.isRequired,
}

export default ModalCloseCertZeroConfirm
